import IconButton from '@mui/material/IconButton'
import React from 'react'
import Tooltip from '@mui/material/Tooltip'
import EditOutlinedIcon from '@mui/icons-material/EditOutlined'

interface ButtonProps {
  // Optional: an icon wrapped in a <Link> navigates via the link and has no handler of its own.
  onClick?: () => void
  title?: string
  disabled?: boolean
  children?: React.ReactNode
  dataTestId?: string
}

export const EditButton: React.FC<ButtonProps> = ({ onClick, disabled = false, title = 'Edit item', children, dataTestId }) => (
  <Tooltip title={title}>
    <IconButton
      data-testid={dataTestId}
      disabled={disabled}
      onClick={onClick}
    >
      {children || <EditOutlinedIcon className={disabled ? 'icon-pantoneBlue--disabled' : 'icon-pantoneBlue'} />}
    </IconButton>
  </Tooltip>
)
